import Vue from 'vue'
import Vuex from 'vuex'
import global from './global'
import cart from './cart'
import location from './location'
import account from './account'

Vue.use(Vuex)

export default new Vuex.Store({
  ...global,
  modules: {
    cart,
    location,
    account
  }
})
